module.exports = "<template> <cost-report-assignments field.bind=field value.two-way=field.value></cost-report-assignments> </template> ";